import { IPaginatedLandingContent } from './models/paginated-landing-content'
import { Filter } from './components/paginated-landing-content-app';

export default function matchesAnyContentTypeHelper(item: IPaginatedLandingContent, filter: Filter[]) {
    let contentTypeResults = item.contentTypes;
    let matchesContentType;

    if (!contentTypeResults || contentTypeResults.length == 0) {
        return false
    }
    // if any filters match any content types on this item
    for (let i = 0; i < contentTypeResults.length; i++) {
        // if any content type result matches
        if (filter.length > 0) {
            for (let n = 0; n < filter.length; n++) {
                if (contentTypeResults[i].toLowerCase() === filter[n].id.toLowerCase()) {
                    matchesContentType = true;
                    break;
                }
            }
            if (matchesContentType) {
                break;
            }
        }
    }
    return matchesContentType;
}
